module.exports = __webpack_public_path__ + "static/img/アセット 25@2x.a4a3fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 25@2x.png
// module id = sb7S
// module chunks = 1